import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import Auth from "./Auth";
import Account from "./Account";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

ReactDOM.render(
    <Router>
        <Switch>
            <Route path="/account">
                <Auth mode="account">
                    <Account />
                </Auth>
            </Route>
            <Route path="/:id">
                <Auth>
                    <App />
                </Auth>
            </Route>
            <Route exact path="/">
                {() => {
                    window.location = "https://www.obama.org";
                }}
            </Route>
        </Switch>
    </Router>,
    document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js